import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { useTranslation } from 'react-i18next';
import { isEqual } from 'lodash';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import { filterOptions } from '../../../helpers/selectHelpers';
import MainTextField from '../MainTextField';

import useStyles from './makeStyles';

const MainSelect = ({ options, value, onChange, getMenuLabel, label, id, name, errors }) => {
  const classes = useStyles();
  const { i18n } = useTranslation();

  const acValue = useMemo(() => options.find((option) => isEqual(option, value)), [options, value]);
  const isError = errors && !!errors[name];

  return (
    <Autocomplete
      key={i18n.language}
      classes={{
        option: classes.option,
      }}
      className={classes.autocompleteRoot}
      options={options}
      getOptionLabel={(option) => getMenuLabel(option) || ''}
      disableClearable
      value={acValue || value}
      onChange={(_, newValue) => {
        onChange(newValue);
      }}
      getOptionSelected={useCallback((option, val) => option.id === val.id, [])}
      PaperComponent={({ children }) => <div className={classes.paper}>{children}</div>}
      filterOptions={filterOptions}
      id={id}
      popupIcon={<KeyboardArrowDownIcon className={classes.icon} />}
      renderInput={(params) => (
        <MainTextField
          {...params}
          required
          variant="outlined"
          label={label}
          name={name}
          error={isError}
          autoComplete="off"
        />
      )}
    />
  );
};

MainSelect.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.shape({})]),
  onChange: PropTypes.func.isRequired,
  getMenuLabel: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  label: PropTypes.string,
  id: PropTypes.string,
  size: PropTypes.string,
  variant: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  name: PropTypes.string,
  errors: PropTypes.shape({}),
};

MainSelect.defaultProps = {
  label: '',
  id: '',
  value: null,
  size: 'small',
  variant: 'outlined',
  required: false,
  disabled: false,
  name: '',
  errors: {},
};

export default MainSelect;
